import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import MapPin from "./mapPin";

export default class SimpleMap extends React.Component {
  static defaultProps = {
    center: {lat: 48.203, lng: 16.363},
    zoom: 15
  };

  constructor(props) {
    super(props);
    this.state = {lat: 48.203, lng: 16.363}
  }

  goToEntry(data) {
    this.setState({
      lat: data.lat,
      lng: data.lng
    })
  }

  render() {
    return (
       <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyCTdHFefKdsM4Xg5M9k5F3_sZla-6uVMvs' }}
        defaultCenter={this.props.center}
        center={this.state}
        defaultZoom={this.props.zoom}
       >
       {this.props.data.map((data, index) =>
         <MapPin
          lat={data.lat}
          lng={data.lng}
          data={data}
          key={`mapPin_${data.location}_${index}`}
          onClick={this.props.onClick}
        />
       )}
      </GoogleMapReact>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/map.js